<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content style="text-align: center;">{{description}}</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{button_no}}</button>
  <button mat-button [mat-dialog-close]="true">{{button_yes}}</button>
</div>